<div class="card-row">
  <h1 class="pc title" translate>HOMEPAGE.ACTION_REPORT.TITLE</h1>
</div>
<div class="sr-only" aria-live="polite" aria-atomic="true">{{ filterRegion1 }}</div>
<div class="sr-only" aria-live="polite" aria-atomic="true">{{ filterRegion2 }}</div>
<app-page-wrapper>
  <div>
    <!-- Info toast: ultime firme (es. ultimi 30 giorni) -->
    <div class="ic1-my-12">
      <ng-ui-kit-toast
        status="info"
        [text]="'ACTION_REPORT_PAGE.LAST_30_DAYS_INFO' | translate">
      </ng-ui-kit-toast>
    </div>

    <div class="under-title">
      <!-- Contatori rimossi: Totale firme / Firme dell'ultima settimana -->
      <div class="actions-row" *ngIf="reportLogs.length > 0">
        <div class="order-by-dropdown" translate>
          <ng-ui-kit-dropdown
            [items]="orderOptions"
            [open]="isDropdownOpen"
            (toggle)="toggleDropdown($event)"
            (onChange)="onSelectOrder($event.value)">
            <button
              dropdownToggle
              type="button"
              class="mobile filter order-toggle"
              [attr.aria-expanded]="isDropdownOpen"
              [attr.aria-haspopup]="true"
              [attr.aria-label]="'ACTION_REPORT_PAGE.ORDER' | translate">
              <div class="action" translate>ACTION_REPORT_PAGE.ORDER</div>
              <img
                src="assets/images/arrow-down.svg"
                class="filter-arrow"
                [ngClass]="{ reversed: isDropdownOpen }" />
            </button>
          </ng-ui-kit-dropdown>
        </div>
      </div>
    </div>

    <!-- ACCORDION SE NON ESISTONO LOG -->
    <div class="ic1-my-16">
      <ng-ui-kit-card
        *ngIf="reportLogs.length === 0"
        type="summative"
        [text]="'ACTION_REPORT_PAGE.NO_LOGS_FOUND' | translate"
        [attr.translate-key]="
          'ACTION_REPORT_PAGE.NO_LOGS_FOUND'
        "></ng-ui-kit-card>
    </div>
    <!-- ACCORDION -->
    <div class="ic1-my-16" *ngFor="let log of paginatedReportLogs">
      <ng-ui-kit-card [data]="true" type="summative" className="history-card">
        <div class="history-row" data>
          <div class="history-left">
            <span class="history-date">
              {{ getLogDate(log.value.executeDate) }}
            </span>
            <span
              class="history-status"
              [ngClass]="
                log.value.result === 'COMPLETED' ? 'is-success' : 'is-failed'
              ">
              {{
                log.value.result === 'COMPLETED'
                  ? ('ACTION_REPORT_PAGE.COMPLETED' | translate)
                  : ('ACTION_REPORT_PAGE.FAILED' | translate)
              }}
            </span>
          </div>
          <div class="history-right" *ngIf="log.value.result === 'COMPLETED'">
            <span class="history-doc-label">
              {{
                log.value.note ===
                'pcvdGwkCjLLNwTV8U+kodVz0SZ7jrJ+oyj6FZMEHevg='
                  ? ('ACTION_REPORT_PAGE.SUBJECT.TECHNICAL_SIGN' | translate)
                  : ('ACTION_REPORT_PAGE.SUBJECT.SIGNED_DOCUMENT' | translate)
              }}:
            </span>
            <span
              class="history-code"
              [ngClass]="{ 'is-empty': !log.value.note }">
              {{ log.value.note || '-' }}
            </span>
            <button
              *ngIf="log.value.note"
              class="history-copy"
              type="button"
              (click)="copyToClipboard(log.value.note)"
              [attr.aria-label]="
                'ACTION_REPORT_PAGE.SUBJECT.COPY_DOCUMENT_CODE' | translate
              ">
              <img src="assets/images/copy-icon.svg" alt="" />
            </button>
          </div>
        </div>
      </ng-ui-kit-card>
    </div>

    <!-- PAGINAZIONE -->
    <!-- <pre>{{ currentPage }} / {{ totalItems }}</pre> -->
    <div class="paginator-row ic1-flex ic1-items-center">
      <div
        class="view-sign paginator-info"
        [innerHTML]="
          'ACTION_REPORT_PAGE.NEW_VIEW_SIGN'
            | translate
              : {
                  start: paginationStart,
                  end: paginationEnd,
                  total: totalItems,
                }
        "></div>
      <!-- <ng-ui-kit-select
        class="ic1-hide-xs ic1-mr-12"
        [options]="options"
        (onChange)="onChangeItemsPerPage($event)"></ng-ui-kit-select> -->

      <ng-ui-kit-paginator
        [items]="totalItems"
        size="sm"
        [currentPage]="currentPage"
        (pageChange)="onPageChanged($event)"
        [itemsPerPage]="itemsPerPage">
      </ng-ui-kit-paginator>
    </div>
  </div>
  <div sidebar *ngIf="showFilter" class="history-filter-sidebar">
    <ng-ui-kit-filter-panel
      [title]="'ACTION_REPORT_PAGE.FILTER' | translate"
      [data]="true"
      [reset]="true"
      [filterPanelBtnLabel]="'ACTION_REPORT_PAGE.RESET' | translate"
      (onReset)="onResetTreeFilters()">
      <div class="ic1-row">
        <!-- 📆 Date Picker -->
        <div class="ic1-col-12 ic1-px-0 data-select">
          <ng-ui-kit-date-select
            [icId]="'date-range-id'"
            [label]="'MULTI_CERT_PAGE.FILTER.DATE' | translate"
            type="date-range"
            [valueRange]="valueRange"
            (onChangeFrom)="onChangeDateFrom($event)"
            (onChangeTo)="onChangeDateTo($event)"
            [labelFrom]="'MULTI_CERT_PAGE.FILTER.DATE' | translate"
            [labelTo]="''"
            [vertical]="true"
            [placeholder]="'ACTION_REPORT_PAGE.PLACEHOLDER_FROM' | translate"
            [options]="{ minDate: dateMinBound, maxDate: dateMaxBound }">
          </ng-ui-kit-date-select>
        </div>
        <!-- ✅ Esito -->

        <div class="ic1-col-12 ic1-pt-24 ic1-px-0 filter-select">
          <div class="ic1-text-label-3" translate>
            ACTION_REPORT_PAGE.RESULT
          </div>
          <ng-ui-kit-select
            icId="resultFilterSelect"
            [options]="resultOptions"
            (onChange)="onResultChange($event)"></ng-ui-kit-select>
        </div>
        <!-- 🔍 Search Button -->
        <div class="ic1-mt-16">
          <app-submit-button
            id="search"
            translate-key="ACTION_REPORT_PAGE.SEARCH"
            class="button-full"
            [label]="'ACTION_REPORT_PAGE.SEARCH' | translate"
            type="button"
            [loading]="loading"
            size="sm"
            (onClick)="onSubmit()">
          </app-submit-button>
        </div>
      </div>
    </ng-ui-kit-filter-panel>
  </div>
</app-page-wrapper>
